import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'navigation-north', 'NavigationNorth', [["path",{"d":"M16 21l-4 -8l-4 8l4 -2l4 2"}],["path",{"d":"M10 9v-6l4 6v-6"}]]);